import script from "./TextBouncing.vue?vue&type=script&setup=true&lang=js"
export * from "./TextBouncing.vue?vue&type=script&setup=true&lang=js"

import "./TextBouncing.vue?vue&type=style&index=0&id=5bba0164&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/coming-soon-template/coming-soon-template/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bba0164"]])

export default __exports__